// Tiny pub/sub bridge between serviceWorkerRegistration (non-React) and the
// app-wide UpdatePrompt. App-scope (not just installer): a root SW affects every
// user, so the reload prompt must reach admins/operators too.
let waiting = null;
const listeners = new Set();

export function setWaitingWorker(worker) {
  waiting = worker;
  listeners.forEach((fn) => fn());
}

export function getWaitingWorker() {
  return waiting;
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function applyUpdate() {
  if (waiting) waiting.postMessage({ type: 'SKIP_WAITING' });
}
